export default function (message, optionalParams = {}) {
    console.log(message, optionalParams);
}
export async function silentReport(e, args) {
    console.log(e, args);
}
